import { DateTime } from 'luxon';

import Container from 'components/container';
import Anchor from 'components/typography/anchor';
import Text from 'components/typography/text';
import facebook from 'images/icons/facebook.svg';
import instagram from 'images/icons/instagram.svg';
import twitter from 'images/icons/twitter.svg';
import youtube from 'images/icons/youtube.svg';
import telegram from 'images/icons/telegram.svg';
import pod from 'images/icons/pod.svg';
import twitch from 'images/icons/twitch.svg';
import reddit from 'images/icons/reddit.svg';
import config from 'siteconfig';

import { footer, social, build } from './footer.module.scss';

const BuildData = () => {
  const commit = process.env.COMMIT_REF;
  const branch = process.env.BRANCH;
  const date = parseInt(process.env.BUILD_DATETIME, 10);

  const buildDate = DateTime.fromSeconds(date)
    .setZone('America/Chicago')
    .toFormat('ccc. LLLL d, yyyy, h:mm a ZZZZ');

  return branch && commit && buildDate ? (
    <div className={build}>
      <Text size="micro" aria-hidden="true">
        Version{' '}
        <code>
          {branch}/{commit}
        </code>{' '}
        built with{' '}
        <span role="img" aria-label="love">
          ❤️
        </span>{' '}
        on {buildDate} by robots without emotions.
      </Text>
    </div>
  ) : null;
};

const Footer = () => (
  <footer role="contentinfo" className={footer}>
    <Container>
      <ul>
        <li>
          <Anchor href="/">Home</Anchor>
        </li>
        <li>
          <Anchor href="/donate">Donate</Anchor>
        </li>
        <li>
          <Anchor href="/guide">Guide</Anchor>
        </li>
        <li>
          <Anchor href="/petitions">Petitions</Anchor>
        </li>
        <li>
          <Anchor href="https://resist.bot/podcasts/live">Live</Anchor>
        </li>
        <li>
          <Anchor
            href="https://cottonbureau.com/people/resistbot"
            rel="external"
          >
            Shop
          </Anchor>
        </li>
        <li>
          <Anchor href="/about">Help</Anchor>
        </li>
        <li>
          <Anchor href={`/${config.blog.baseURL}`}>News</Anchor>
        </li>
      </ul>
      <Text>
        Resistbot is a free service, but message and data rates may apply if you
        use the service over SMS. Message frequency varies. Text STOP to 50409
        to stop all messages. Text HELP to 50409 for help. Here are our full{' '}
        <Anchor href="/terms">terms</Anchor> and{' '}
        <Anchor href="/privacy">privacy&nbsp;notice</Anchor> and{' '}
        <Anchor href="/rights">user bill of&nbsp;rights</Anchor>.
      </Text>
      <Text size="small">
        Resistbot is a product <em>of</em> the Resistbot Action Fund, a
        501(c)(4) social welfare organization. Since we lobby on your behalf,
        donations are not tax-deductible as charitable&nbsp;contributions.
      </Text>
      <Text size="small">
        260 1st Ave. S.
        <br />
        Suite 200 Box 51
        <br />
        Saint Petersburg, Fla. 33701
      </Text>
      <div className={social}>
        <Anchor href="https://twitter.com/intent/follow?screen_name=resistbot">
          <img src={twitter} alt="Twitter" />
        </Anchor>
        <Anchor href="https://facebook.com/resistbot">
          <img src={facebook} alt="Facebook" />
        </Anchor>
        <Anchor href="https://instagram.com/resistbot">
          <img src={instagram} alt="Instagram" />
        </Anchor>
        <Anchor href="https://t.me/resistbot">
          <img src={telegram} alt="Telegram" />
        </Anchor>
        <Anchor href="https://podcasts.apple.com/us/podcast/resistbot-live/id1587774264">
          <img src={pod} alt="Apple Podcasts" />
        </Anchor>
        <Anchor href="https://www.youtube.com/channel/UCEiQinjQvseC-U7Bs6sSpVQ">
          <img src={youtube} alt="Youtube" />
        </Anchor>
        <Anchor href="https://twitch.tv/resistbot">
          <img src={twitch} alt="Twitch" />
        </Anchor>
        <Anchor href="https://www.reddit.com/r/resistbot/">
          <img src={reddit} alt="Reddit" />
        </Anchor>
      </div>
      <BuildData />
    </Container>
  </footer>
);

export default Footer;
